module.exports = __webpack_public_path__ + "static/media/course.e306b826.png";